module.exports = __webpack_public_path__ + "static/BT-mobile-12-2e7e575c2fcdd40cc84cd83e42714b06.jpg";